"use strict";
import { TMSLoad } from "./tms_load";
export class LoadState {
  constructor(loadState) {
    this.loadState = loadState;
    this.load = new TMSLoad(this.loadState.load);
  }
}
